import { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaHome, FaGift } from "react-icons/fa";
import { LuTags } from "react-icons/lu";

import BrandAvatar from "../BrandAvatar/BrandAvatar";
import ThemeToggle from "../ThemeToggle/ThemeToggle";
import styles from "./Navbar.module.scss";

const navItems = [
  { to: "/", label: "Inicio", icon: <FaHome /> },
  { to: "/ofertas", label: "Ofertas", icon: <LuTags /> },
  { to: "/sorteos", label: "Sorteos", icon: <FaGift /> },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const closeMenu = () => {
    setOpen(false);
  };

  return (
    <header className={styles.navbar}>
      <nav className={`navbar navbar-expand-lg ${styles.nav}`}>
        <div className={`container ${styles.container}`}>
          <NavLink to="/" className={`navbar-brand ${styles.brandLink}`} onClick={closeMenu}>
            <BrandAvatar name="Kitos" />
          </NavLink>

          <div className={styles.mobileActions}>
            <ThemeToggle className={styles.themeToggleMobile} />
            <button
              className={`${styles.toggler} ${open ? styles.togglerOpen : ""}`}
              type="button"
              onClick={() => setOpen((current) => !current)}
              aria-controls="mainNavbar"
              aria-expanded={open}
              aria-label={open ? "Cerrar menú" : "Abrir menú"}
            >
              <span className={styles.burger} aria-hidden="true">
                <span />
                <span />
                <span />
              </span>
            </button>
          </div>

          <div
            className={`${styles.menu} ${open ? styles.menuOpen : ""}`}
            id="mainNavbar"
          >
            <div className={styles.menuInner}>
              <ul className={styles.menuList}>
                {navItems.map((item) => (
                  <li className="nav-item" key={item.to}>
                    <NavLink
                      to={item.to}
                      onClick={closeMenu}
                      className={({ isActive }) =>
                        isActive
                          ? `nav-link ${styles.link} ${styles.active}`
                          : `nav-link ${styles.link}`
                      }
                    >
                      {item.icon}
                      {item.label}
                    </NavLink>
                  </li>
                ))}
                <li className={`nav-item ${styles.desktopTheme}`}>
                  <ThemeToggle />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}
